<template>
  <div class="consumables">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <b-button v-if="(!is_template && currentUserAccess('ConsumableDetails', this.UserActions.CREATE, this.project_id))
                            || (is_template && currentUserAccess('ProjectTemplates', this.UserActions.CREATE))" 
                      class="button is-primary" icon-left="plus-thick" @click="addNewConsumableClicked">
              {{ $t('consumables-view.new-consumable-button') }}
            </b-button>
            <b-table class="consumables-table" :data="consumablesData" :striped="true" :hoverable="false"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="consumable.resource" :label="this.$t('consumables-view.consumable-resource-column')" v-slot="props" sortable searchable>
                <router-link :to="{ name: 'ConsumableDetails', params: { project_id:project_id, consumable_id:props.row.consumable.document_id, is_template: is_template }}">
                  {{ getAdjustedTitle(props.row.consumable.resource) }}
                </router-link>
              </b-table-column>
              <b-table-column field="consumable.category" :label="this.$t('consumables-view.consumable-category-column')"
                              v-slot="props" sortable searchable>
                {{ props.row.consumable.category }}
              </b-table-column>
              <b-table-column field="consumable.provider" :label="this.$t('consumables-view.consumable-provider-column')"
                              v-slot="props" sortable searchable>
                {{ props.row.consumable.provider }}
              </b-table-column>
              <b-table-column field="consumable.meta.estimation.quantity" :label="this.$t('consumables-view.consumable-quantity-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedQuantity(props.row.consumable.meta.estimation, props.row.consumable.unit) }}
              </b-table-column>
              <b-table-column field="consumable.meta.estimation.fee_per_unit" :label="this.$t('consumables-view.consumable-fee-per-unit-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedFeePerUnit(props.row.consumable.meta.estimation) }}
              </b-table-column>
              <b-table-column field="consumable.meta.estimation.expected_total_fee" :label="this.$t('consumables-view.consumable-total-fee-column')"
                              v-slot="props" width="10%" sortable>
                {{ getFormattedPricing(props.row.estimation.expected_total_fee) }}
              </b-table-column>
              <b-table-column field="text" :label="this.$t('consumables-view.consumable-text-column')" v-slot="props" width="22%">
                {{ truncateColumn(props.row.consumable.text) }}
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <ConsumableDetails v-bind:project_id="project_id" v-bind:consumable_id="'new'" @close="props.close"
                            @consumableAdded="readConsumablesData"></ConsumableDetails>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import ConsumableDetails from "@/components/ConsumableDetails";
import firebase from "firebase/app";

export default {
  name: "Consumables",
  components: {
    ConsumableDetails
  },
  props: {
    'project_id': {
      type: String,
    },
    'is_template': {
      type: Boolean,
    }
  },
  data() {
    return {
      consumablesData: [],
      isLoading: false,
      isModalActive: false
    }
  },
  methods: {
    readConsumablesData: function () {
      this.isModalActive = false;
      this.isLoading = true;
      this.consumablesData = [];
      const functions = firebase.app().functions("europe-west3");
      const getConsumablesFunction = functions.httpsCallable(this.getSubmitEndpoint());
      console.log("project_id: ", this.project_id);
      getConsumablesFunction({action: "get_consumables", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("consumable list result: ", result.data);
            if (result.data.consumables.length > 0) {
              result.data["consumables"].forEach((consumable) => {
                this.consumablesData.push({
                  consumable: consumable,
                  estimation: consumable.meta.estimation ? consumable.meta.estimation : {}
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting consumables: ", error);
          });
      this.isLoading = false;
    },
    /*
     UI Events
     */
    addNewConsumableClicked: function () {
      this.isModalActive = true;
    }
  },
  mounted() {
    this.readConsumablesData();
  }
};
</script>

<style scoped>
.consumables-table {
  margin-top: 16px;
}
</style>
